module.exports = __webpack_public_path__ + "media/images/icons/material/instagram-dd7152a73d6678449ef334845aaa1385.svg";